import { Divider, Grid } from '@mui/material';
import * as React from 'react';
import CustomSelect from '../Form/CustomSelect';


export default function TablePageControl({ length, setLength, page, setPage, totalPage }) {
    const pageLengthList = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
        { label: 40, value: 40 },
        { label: 50, value: 50 }
    ]
    const [pageList, setPageList] = React.useState();

    React.useEffect(() => {
        if (totalPage) {
            let tempPageList = [];
            for (let index = 0; index < totalPage; index++) {
                tempPageList.push({ label: index + 1, value: index + 1 })
            }
            setPageList(tempPageList);
        }

    }, [totalPage])
    return (
        <React.Fragment>
            <Divider className="divider-style" />
            <Grid container color={'#A0A0A0'}>
                <Grid item lg={6} md={6} sm={6} xs={12} display={'flex'} alignItems={'center'}>
                    Show
                    <div className="mx-2">
                        <CustomSelect
                            values={length}
                            onChange={(e) => {setLength(e); setPage(1)}}
                            width={100}
                            height={32}
                            data={pageLengthList}
                            ableClear={false}
                        />
                    </div>
                    per page
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12} display={'flex'} justifyContent={{ sm: 'end', xs: 'start' }}>
                    <div className="page-container">
                        Page
                    </div>
                    <CustomSelect
                        values={page || 1}
                        onChange={setPage}
                        width={80 + ((page)?.toString()?.length || 1) * 20}
                        height={40}
                        noBorderRadius={true}
                        ableClear={false}
                        data={pageList || [{ label: 1, value: 1 }]}
                    />
                    <div className="total-page-container" >of <span className='mx-1'>{totalPage || '1'}</span></div>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
